import { render } from "./MMBoardMembers.vue?vue&type=template&id=775d4b36"
import script from "./MMBoardMembers.vue?vue&type=script&lang=js"
export * from "./MMBoardMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__